<div class="w-full h-full flex flex-col py-6 px-6">
  <!-- Options bar -->
  <div class="flex-0 mb-1 flex justify-end dark:text-gray-300 text-sm">
    <button type="button" class="ml-2 dark-btn"
      [class.dark-btn-disabled]="!scanners_loaded" [disabled]="!scanners_loaded"
      (click)="on_add_scanner_click()">
      <i class="fa-solid fa-fw fa-clone mr-1 dark:text-blue-400"></i> Add Scanner
    </button>
    <button type="button" class="ml-2 dark-btn" [class.dark-btn-disabled]="!can_edit_scanner()" [disabled]="!can_edit_scanner()" (click)="on_edit_scanner_click()">
      <i class="fa-solid fa-fw fa-pen mr-1 dark:text-blue-400"></i> Edit Scanner
    </button>
    <button type="button" class="ml-2 dark-btn" [class.dark-btn-disabled]="!can_delete_scanner()" [disabled]="!can_delete_scanner()" (click)="on_delete_scanner_click()">
      <i class="fa-solid fa-fw fa-trash mr-1 dark:text-red-500"></i> Delete Scanner
    </button>
    <button type="button" class="ml-2 dark-btn" (click)="verify_all()">
      <i class="fa-solid fa-fw fa-circle-check mr-1 dark:text-amber-400"></i> Verify URLs
    </button>
    <button type="button" class="ml-2 dark-btn" (click)="refresh()">
      <i class="fa-solid fa-fw fa-sync mr-1 dark:text-green-600"></i> Refresh
    </button>
  </div>

  <!-- Grid -->
  <ag-grid-angular
    class="flex-1 w-full h-[600px]"
    [theme]="theme"
    [gridOptions]="grid.options"
    [columnDefs]="grid.columnDefs"
    [rowData]="scanners"
    [statusBar]="grid.statusBar"
    (gridReady)="on_grid_ready($event)"
    (firstDataRendered)="on_first_data_rendered($event)"
    (modelUpdated)="on_model_updated($event)"
    (rowSelected)="on_row_selected($event)"
  />
</div>


<!-- Add Scanner drawer (right-side slide-in — same shape as Edit) -->
<div *ngIf="showAddScannerModal"
     class="fixed inset-0 z-40 dark:bg-[rgba(1,1,1,0.5)]"
     (click)="showAddScannerModal = false">
  <div class="fixed top-0 right-0 bottom-0 z-50 w-[560px] max-w-full flex flex-col shadow-2xl dark:bg-app-black-200"
       (click)="$event.stopPropagation()">
    <div class="flex-none flex items-center justify-between py-3 px-6 dark:bg-app-black-100 border-b dark:border-app-black-300">
      <div class="min-w-0 flex-1">
        <h1 class="text-md md:text-lg font-semibold leading-tight tracking-tight text-gray-900 dark:text-white truncate">
          <i class="fa-solid fa-clone text-strat_orange-100 mr-2"></i>{{ newScanner?.Name || 'Add Scanner' }}
        </h1>
        <div *ngIf="newScanner?.Id" class="mt-0.5 text-xs text-gray-500 dark:text-gray-400 font-mono truncate">{{ newScanner.Id }}</div>
      </div>
      <button type="button" (click)="showAddScannerModal = false" class="ml-3 text-gray-500 dark:text-gray-400 hover:text-black dark:hover:text-white text-2xl leading-none px-1 shrink-0">&times;</button>
    </div>
    <form class="flex-1 overflow-y-auto py-4 px-6 dark:bg-gradient-to-b from-app-black-200 to-app-black-300">
      <div>
        <label for="scanner_client" class="block mb-1 text-sm font-medium text-gray-900 dark:text-white">Client*</label>
        <div class="flex gap-2">
          <select name="scanner_client" [ngModel]="newScanner.Client" (ngModelChange)="newScanner.Client = $event; on_client_change($event)" class="bg-gray-50 border border-gray-300 text-gray-900 rounded-md block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-strat_orange-100 dark:focus:border-strat_orange-100" required>
            <option [value]="''" disabled>— Select a customer —</option>
            <option *ngFor="let c of customers" [value]="c._id">{{ c.name || c._id }} ({{ c._id }})</option>
          </select>
          <button type="button" (click)="open_add_customer('add')" title="Add a new customer" class="dark-btn px-3">
            <i class="fa-solid fa-plus dark:text-blue-400"></i>
          </button>
        </div>
        <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">Pick an existing customer or click + to add a new one.</p>
      </div>
      <div class="mt-4">
        <label for="scanner_id" class="block mb-1 text-sm font-medium text-gray-900 dark:text-white">Id*</label>
        <input name="scanner_id" autocomplete="off" [(ngModel)]="newScanner.Id" class="bg-gray-50 border border-gray-300 text-gray-900 rounded-md focus:ring-primary-600 focus:border-primary-600 block w-full p-2 font-mono text-xs dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-strat_orange-100 dark:focus:border-strat_orange-100" required>
        <p *ngIf="id_already_exists()" class="mt-1 text-xs text-red-500">A scanner with this Id already exists.</p>
        <p *ngIf="newScanner.Client && newScanner.Id && !id_already_exists()" class="mt-1 text-xs text-gray-500 dark:text-gray-400">Append a suffix to make the Id unique.</p>
      </div>
      <div class="mt-4">
        <label for="scanner_name" class="block mb-1 text-sm font-medium text-gray-900 dark:text-white">Name*</label>
        <input name="scanner_name" autocomplete="off" [(ngModel)]="newScanner.Name" class="bg-gray-50 border border-gray-300 text-gray-900 rounded-md focus:ring-primary-600 focus:border-primary-600 block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-strat_orange-100 dark:focus:border-strat_orange-100" required>
      </div>
      <div class="mt-4">
        <label for="scanner_short_name" class="block mb-1 text-sm font-medium text-gray-900 dark:text-white">Short Name</label>
        <input name="scanner_short_name" autocomplete="off" [(ngModel)]="newScanner.ShortName" placeholder="e.g. RPZ Scanner"
               class="bg-gray-50 border border-gray-300 text-gray-900 rounded-md focus:ring-primary-600 focus:border-primary-600 block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-strat_orange-100 dark:focus:border-strat_orange-100">
        <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">Optional. Used as the compact label in commerce welcome email subject lines (<code class="text-app-teal-100">[ShortName] Your Scanner Login Credentials</code>). Falls back to <b>Name</b> when blank.</p>
      </div>
      <div class="mt-4">
        <label for="scanner_aliases" class="block mb-1 text-sm font-medium text-gray-900 dark:text-white">Slug Aliases</label>
        <!-- IT-F2-459 Mike 2026-11-02 — tags-style input. Chips derived
             from newScanner.aliasesCsv; Enter / comma commits a chip,
             Backspace on empty input pops the last. Clicking anywhere
             on the field focuses the input. -->
        <div class="w-full border border-gray-300 bg-gray-50 text-gray-900 dark:border-gray-600 dark:bg-gray-700 dark:text-white rounded-md p-2 flex items-center flex-wrap gap-1 cursor-text min-h-[2.5rem]"
             (click)="newAliasInputRef.focus()">
          <span *ngFor="let a of newAliasesList; let i = index"
                class="inline-flex items-center gap-1 bg-app-teal-100/20 text-app-teal-100 text-xs px-2 py-0.5 rounded font-mono">
            {{ a }}
            <button type="button" class="hover:text-white" (click)="remove_new_alias(i); $event.stopPropagation()" title="Remove">
              <i class="fa-solid fa-xmark text-[10px]"></i>
            </button>
          </span>
          <input #newAliasInputRef type="text" class="flex-1 min-w-[8rem] bg-transparent outline-none text-xs font-mono"
                 [(ngModel)]="newAliasInput" name="newAliasInput"
                 (keydown)="on_alias_keydown($event, 'new')"
                 (blur)="add_new_alias(newAliasInput)"
                 placeholder="type then Enter or comma" />
        </div>
        <input type="hidden" name="scanner_aliases_hidden" [(ngModel)]="newScanner.aliasesCsv" />
        <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">Portal-mint slug variants (/validate-*-token) + URL-routing on branded hosts (IT-F2-459). Stored lowercased. Blank = no aliases.</p>
      </div>
      <div class="mt-4">
        <label for="scanner_url" class="block mb-1 text-sm font-medium text-gray-900 dark:text-white">URL</label>
        <input name="scanner_url" autocomplete="off" [(ngModel)]="newScanner.Url" placeholder="https://ai.optionpit.com/scans/option-pit" class="bg-gray-50 border border-gray-300 text-gray-900 rounded-md focus:ring-primary-600 focus:border-primary-600 block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-strat_orange-100 dark:focus:border-strat_orange-100" >
        <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">Per-scanner deep link. Blank is OK if App URL is set.</p>
      </div>
      <div class="mt-4">
        <label for="scanner_appurl" class="block mb-1 text-sm font-medium text-gray-900 dark:text-white">App URL</label>
        <input name="scanner_appurl" autocomplete="off" [(ngModel)]="newScanner.AppUrl" placeholder="https://ai.optionpit.com" class="bg-gray-50 border border-gray-300 text-gray-900 rounded-md focus:ring-primary-600 focus:border-primary-600 block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-strat_orange-100 dark:focus:border-strat_orange-100" >
        <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">SPA root for this scanner. Used as fallback when URL is blank.</p>
      </div>
      <div class="mt-4">
        <label for="scanner_role_access" class="block mb-1 text-sm font-medium text-gray-900 dark:text-white">Role Access*</label>
        <select name="scanner_role_access" [(ngModel)]="newScanner.RoleAccess" class="bg-gray-50 border border-gray-300 text-gray-900 rounded-md block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-strat_orange-100 dark:focus:border-strat_orange-100" required>
          <option *ngFor="let r of roleAccessOptions" [value]="r">{{ r }}</option>
        </select>
        <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">Lowest viewer role that sees this scanner. disabled = hidden.</p>
      </div>
    </form>
    <div class="flex-none py-3 px-6 border-t dark:border-app-black-300 dark:bg-app-black-100 flex gap-2">
      <button type="button" (click)="showAddScannerModal = false" class="dark-btn-secondary flex-1">Cancel</button>
      <button type="button" (click)="on_create_scanner()" [disabled]="!can_create_scanner()"
        class="dark-btn-primary flex-1" [class.dark-btn-disabled]="!can_create_scanner()">Save</button>
    </div>
  </div>
</div>

<!-- Edit Scanner drawer (right-side slide-in) -->
<div *ngIf="showEditScannerModal"
     class="fixed inset-0 z-40 dark:bg-[rgba(1,1,1,0.5)]"
     (click)="showEditScannerModal = false">
  <div class="fixed top-0 right-0 bottom-0 z-50 w-[560px] max-w-full flex flex-col shadow-2xl dark:bg-app-black-200"
       (click)="$event.stopPropagation()">
    <!-- Sticky title bar. Live-updating from editScanner.Name (falls back
         to the original selected_scanner.Name so the header keeps a stable
         label if the user clears the input while typing a rename). -->
    <div class="flex-none flex items-center justify-between py-3 px-6 dark:bg-app-black-100 border-b dark:border-app-black-300">
      <div class="min-w-0 flex-1">
        <h1 class="text-md md:text-lg font-semibold leading-tight tracking-tight text-gray-900 dark:text-white truncate">
          <i class="fa-solid fa-pen text-blue-400 mr-2"></i>{{ editScanner?.Name || selected_scanner?.Name || 'Edit Scanner' }}
        </h1>
        <div *ngIf="editScanner?.Id" class="mt-0.5 text-xs text-gray-500 dark:text-gray-400 font-mono truncate">{{ editScanner.Id }}</div>
      </div>
      <button type="button" (click)="showEditScannerModal = false" class="ml-3 text-gray-500 dark:text-gray-400 hover:text-black dark:hover:text-white text-2xl leading-none px-1 shrink-0">&times;</button>
    </div>
    <!-- Scrolling settings body. flex-1 + overflow-y-auto pins the header
         above and the action bar below while the middle scrolls. -->
    <form class="flex-1 overflow-y-auto py-4 px-6 dark:bg-gradient-to-b from-app-black-200 to-app-black-300">
      <div>
        <label for="edit_scanner_client" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Client*</label>
        <div class="flex gap-2">
          <select name="edit_scanner_client" [(ngModel)]="editScanner.Client" class="bg-gray-50 border border-gray-300 text-gray-900 rounded-md block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-strat_orange-100 dark:focus:border-strat_orange-100" required>
            <option [value]="''" disabled>— Select a customer —</option>
            <option *ngFor="let c of customers" [value]="c._id">{{ c.name || c._id }} ({{ c._id }})</option>
          </select>
          <button type="button" (click)="open_add_customer('edit')" title="Add a new customer" class="dark-btn px-3">
            <i class="fa-solid fa-plus dark:text-blue-400"></i>
          </button>
        </div>
      </div>
      <!-- Name first so operator sees the human-readable label before all the machine slugs -->
      <div class="mt-4">
        <label for="edit_scanner_name" class="block mb-1 text-sm font-medium text-gray-900 dark:text-white">Name*</label>
        <input name="edit_scanner_name" autocomplete="off" [(ngModel)]="editScanner.Name" class="bg-gray-50 border border-gray-300 text-gray-900 rounded-md focus:ring-primary-600 focus:border-primary-600 block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-strat_orange-100 dark:focus:border-strat_orange-100" required>
      </div>
      <div class="mt-4">
        <label for="edit_scanner_short_name" class="block mb-1 text-sm font-medium text-gray-900 dark:text-white">Short Name</label>
        <input name="edit_scanner_short_name" autocomplete="off" [(ngModel)]="editScanner.ShortName" placeholder="e.g. RPZ Scanner"
               class="bg-gray-50 border border-gray-300 text-gray-900 rounded-md focus:ring-primary-600 focus:border-primary-600 block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-strat_orange-100 dark:focus:border-strat_orange-100">
        <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">Optional. Used as the compact label in commerce welcome email subject lines (<code class="text-app-teal-100">[ShortName] Your Scanner Login Credentials</code>). Falls back to <b>Name</b> when blank.</p>
      </div>
      <div class="mt-4">
        <label class="block mb-1 text-sm font-medium text-gray-900 dark:text-white">Id (read-only)</label>
        <input [value]="editScanner.Id" disabled class="bg-gray-100 border border-gray-300 text-gray-500 rounded-md block w-full p-2 font-mono text-xs dark:bg-app-black-100 dark:border-gray-600 dark:text-gray-400 cursor-not-allowed">
      </div>
      <div class="mt-4">
        <label for="edit_scanner_aliases" class="block mb-1 text-sm font-medium text-gray-900 dark:text-white">Slug Aliases</label>
        <!-- IT-F2-459 Mike 2026-11-02 — tags-style input (clar
             69720f8a: reuse existing lowercase 'aliases' field). -->
        <div class="w-full border border-gray-300 bg-gray-50 text-gray-900 dark:border-gray-600 dark:bg-gray-700 dark:text-white rounded-md p-2 flex items-center flex-wrap gap-1 cursor-text min-h-[2.5rem]"
             (click)="editAliasInputRef.focus()">
          <span *ngFor="let a of editAliasesList; let i = index"
                class="inline-flex items-center gap-1 bg-app-teal-100/20 text-app-teal-100 text-xs px-2 py-0.5 rounded font-mono">
            {{ a }}
            <button type="button" class="hover:text-white" (click)="remove_edit_alias(i); $event.stopPropagation()" title="Remove">
              <i class="fa-solid fa-xmark text-[10px]"></i>
            </button>
          </span>
          <input #editAliasInputRef type="text" class="flex-1 min-w-[8rem] bg-transparent outline-none text-xs font-mono"
                 [(ngModel)]="editAliasInput" name="editAliasInput"
                 (keydown)="on_alias_keydown($event, 'edit')"
                 (blur)="add_edit_alias(editAliasInput)"
                 placeholder="type then Enter or comma" />
        </div>
        <input type="hidden" name="edit_scanner_aliases_hidden" [(ngModel)]="editAliasesCsv" />
        <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">Portal-mint slug variants (/validate-*-token) + URL-routing on branded hosts (IT-F2-459). Stored lowercased. Blank = no aliases.</p>
      </div>
      <div class="mt-4">
        <label for="edit_scanner_url" class="block mb-1 text-sm font-medium text-gray-900 dark:text-white">URL</label>
        <input name="edit_scanner_url" autocomplete="off" [(ngModel)]="editScanner.Url" placeholder="https://ai.optionpit.com/scans/option-pit" class="bg-gray-50 border border-gray-300 text-gray-900 rounded-md focus:ring-primary-600 focus:border-primary-600 block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-strat_orange-100 dark:focus:border-strat_orange-100">
        <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">Per-scanner deep link. Blank is OK if App URL is set.</p>
      </div>
      <div class="mt-4">
        <label for="edit_scanner_appurl" class="block mb-1 text-sm font-medium text-gray-900 dark:text-white">App URL</label>
        <input name="edit_scanner_appurl" autocomplete="off" [(ngModel)]="editScanner.AppUrl" placeholder="https://ai.optionpit.com" class="bg-gray-50 border border-gray-300 text-gray-900 rounded-md focus:ring-primary-600 focus:border-primary-600 block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-strat_orange-100 dark:focus:border-strat_orange-100">
        <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">SPA root for this scanner. Used as fallback when URL is blank.</p>
      </div>
      <div class="mt-4">
        <label for="edit_scanner_role_access" class="block mb-1 text-sm font-medium text-gray-900 dark:text-white">Role Access*</label>
        <select name="edit_scanner_role_access" [(ngModel)]="editScanner.RoleAccess" class="bg-gray-50 border border-gray-300 text-gray-900 rounded-md block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-strat_orange-100 dark:focus:border-strat_orange-100" required>
          <option *ngFor="let r of roleAccessOptions" [value]="r">{{ r }}</option>
        </select>
        <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">Lowest viewer role that sees this scanner. disabled = hidden.</p>
      </div>
      <div class="mt-4">
        <label class="block mb-1 text-sm font-medium text-gray-900 dark:text-white">DataSource (JSON)</label>
        <textarea name="edit_scanner_datasource" [(ngModel)]="editDataSourceJson" rows="5"
                  placeholder='{ "Server": "...", "LiveDbPattern": "...", "Collections": [] }'
                  class="bg-gray-50 border border-gray-300 text-gray-900 rounded-md block w-full p-2 font-mono text-xs dark:bg-gray-700 dark:border-gray-600 dark:text-white"></textarea>
        <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">Server, LiveDbPattern, DelayedDbPattern, Collections, Notes. Blank to clear.</p>
      </div>
      <div class="mt-4">
        <label class="block mb-1 text-sm font-medium text-gray-900 dark:text-white">Stream</label>
        <div class="flex items-center gap-2">
          <button type="button" (click)="openStreamEditor()"
                  class="dark-btn-secondary text-xs px-3 py-1 flex items-center gap-2">
            <i class="fa-solid fa-tower-broadcast text-[10px]"></i>
            Edit streams
          </button>
          <span class="text-xs text-gray-500 dark:text-gray-400">
            {{ (editStreamArray?.length || 0) }} entr{{ (editStreamArray?.length || 0) === 1 ? 'y' : 'ies' }}
          </span>
        </div>
        <app-stream-editor
          [stream]="editStreamArray"
          [scannerId]="editScanner.Id"
          [showModal]="showStreamEditor"
          (streamChange)="editStreamArray = $event"
          (closeModal)="showStreamEditor = false"></app-stream-editor>
        <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">WebSocket/REST route definitions. Remove all to clear the field.</p>
      </div>
      <!-- IT-F2-406 cid 9c3a4daf — Scanners.<id>.channels[] catalog editor. -->
      <div class="mt-4">
        <label class="block mb-1 text-sm font-medium text-gray-900 dark:text-white">Channels</label>
        <div class="flex items-center gap-2">
          <button type="button" (click)="openChannelsCatalogEditor()"
                  class="dark-btn-secondary text-xs px-3 py-1 flex items-center gap-2">
            <i class="fa-solid fa-list-ul text-[10px]"></i>
            Edit channels
          </button>
          <span class="text-xs text-gray-500 dark:text-gray-400">
            {{ (editChannelsArray?.length || 0) }} channel{{ (editChannelsArray?.length || 0) === 1 ? '' : 's' }}
          </span>
        </div>
        <app-channels-catalog-editor
          [channels]="editChannelsArray"
          [scannerId]="editScanner.Id"
          [showModal]="showChannelsCatalogEditor"
          [streamRef]="editStreamArray"
          (channelsChange)="editChannelsArray = $event"
          (closeModal)="showChannelsCatalogEditor = false"></app-channels-catalog-editor>
        <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
          Per-scanner channel catalog with role-visibility gates. Drives the Edit Channels dialog on the Users panel + sidebar sub-tape list + WS/REST channel entitlement. Remove all to clear.
        </p>
      </div>
      <div class="mt-4">
        <label class="block mb-1 text-sm font-medium text-gray-900 dark:text-white">Exclude TLDs (JSON array)</label>
        <input name="edit_scanner_exclude_tlds" [(ngModel)]="editExcludeTldsJson" placeholder='["ai"] or blank'
               class="bg-gray-50 border border-gray-300 text-gray-900 rounded-md block w-full p-2 font-mono text-xs dark:bg-gray-700 dark:border-gray-600 dark:text-white">
        <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">Hide from members on listed TLDs. Blank or [] = show on all.</p>
      </div>
      <div class="mt-4" *ngIf="selected_scanner?.verified">
        <label class="block mb-1 text-sm font-medium text-gray-900 dark:text-white">Verified (read-only)</label>
        <div class="bg-gray-100 dark:bg-app-black-100 border border-gray-300 dark:border-gray-600 rounded-md p-2 text-xs font-mono text-gray-700 dark:text-gray-300">
          <span [class.text-green-600]="selected_scanner.verified.ok" [class.text-red-500]="!selected_scanner.verified.ok" class="dark:font-semibold">
            <i class="fa-solid mr-1" [class.fa-circle-check]="selected_scanner.verified.ok" [class.fa-circle-xmark]="!selected_scanner.verified.ok"></i>
            HTTP {{ selected_scanner.verified.status || '?' }}
          </span>
          <span class="ml-2 text-gray-500 dark:text-gray-400">checked {{ selected_scanner.verified.checked_at }}</span>
          <div *ngIf="selected_scanner.verified.error" class="mt-1 text-red-500">{{ selected_scanner.verified.error }}</div>
        </div>
      </div>
      <!-- GitHub Collab panel (IT-F2-178) — collapsible; body only shown when enabled -->
      <div class="mt-6 pt-4 border-t border-gray-200 dark:border-app-black-100">
        <label class="flex items-center gap-2 text-sm font-medium text-gray-900 dark:text-white cursor-pointer">
          <input type="checkbox" name="edit_github_collab_enabled" [(ngModel)]="editGithubCollabEnabled"
                 class="w-4 h-4 text-primary-600 bg-gray-100 border-gray-300 rounded focus:ring-primary-500 dark:bg-gray-700 dark:border-gray-600">
          <i class="fa-brands fa-github mr-1"></i>
          GitHub Collab
        </label>
        <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
          Optional. Enable when this scanner has a two-repo customer-collab GitHub flow (customer collab repo + F2-private deploy target + automation App).
          Reference impl: <code class="text-app-teal-100">as-thestrat</code>.
        </p>

        <div *ngIf="editGithubCollabEnabled" class="mt-3 pl-6 border-l-2 border-blue-400/40 dark:border-blue-500/40 space-y-3">
          <!-- Customer-facing collab repo -->
          <div>
            <label class="block mb-1 text-xs font-medium text-gray-700 dark:text-gray-300">Customer collab repo* (customer opens PRs here)</label>
            <div class="flex gap-2">
              <input name="gc_collab_owner" autocomplete="off" [(ngModel)]="editGithubCollab.collab.owner" placeholder="owner (e.g. F2-Strat)"
                     class="bg-gray-50 border border-gray-300 text-gray-900 rounded-md block w-1/2 p-2 font-mono text-xs dark:bg-gray-700 dark:border-gray-600 dark:text-white">
              <input name="gc_collab_repo" autocomplete="off" [(ngModel)]="editGithubCollab.collab.repo" placeholder="repo (e.g. thestrat-frontend)"
                     class="bg-gray-50 border border-gray-300 text-gray-900 rounded-md block w-1/2 p-2 font-mono text-xs dark:bg-gray-700 dark:border-gray-600 dark:text-white">
            </div>
          </div>
          <!-- F2-private deploy target repo -->
          <div>
            <label class="block mb-1 text-xs font-medium text-gray-700 dark:text-gray-300">F2-private deploy target* (Vercel deploys from this)</label>
            <div class="flex gap-2">
              <input name="gc_private_owner" autocomplete="off" [(ngModel)]="editGithubCollab.private.owner" placeholder="owner (e.g. F2Tech-WebDev-v2)"
                     class="bg-gray-50 border border-gray-300 text-gray-900 rounded-md block w-1/2 p-2 font-mono text-xs dark:bg-gray-700 dark:border-gray-600 dark:text-white">
              <input name="gc_private_repo" autocomplete="off" [(ngModel)]="editGithubCollab.private.repo" placeholder="repo (e.g. thestrat-frontend)"
                     class="bg-gray-50 border border-gray-300 text-gray-900 rounded-md block w-1/2 p-2 font-mono text-xs dark:bg-gray-700 dark:border-gray-600 dark:text-white">
            </div>
          </div>
          <!-- Automation App -->
          <div>
            <label class="block mb-1 text-xs font-medium text-gray-700 dark:text-gray-300">Automation App (GitHub App wiring the two together — optional)</label>
            <div class="flex gap-2">
              <input name="gc_app_slug" autocomplete="off" [(ngModel)]="editGithubCollab.app.slug" placeholder="slug (e.g. claude-app-webdev)"
                     class="bg-gray-50 border border-gray-300 text-gray-900 rounded-md block flex-1 p-2 font-mono text-xs dark:bg-gray-700 dark:border-gray-600 dark:text-white">
              <input name="gc_app_id" type="number" autocomplete="off" [(ngModel)]="editGithubCollab.app.app_id" placeholder="app_id (e.g. 4499985)"
                     class="bg-gray-50 border border-gray-300 text-gray-900 rounded-md block w-32 p-2 font-mono text-xs dark:bg-gray-700 dark:border-gray-600 dark:text-white">
              <input name="gc_app_client_id" autocomplete="off" [(ngModel)]="editGithubCollab.app.client_id" placeholder="client_id"
                     class="bg-gray-50 border border-gray-300 text-gray-900 rounded-md block flex-1 p-2 font-mono text-xs dark:bg-gray-700 dark:border-gray-600 dark:text-white">
            </div>
          </div>
          <!-- Workflow file paths -->
          <div>
            <label class="block mb-1 text-xs font-medium text-gray-700 dark:text-gray-300">Workflow file paths (optional)</label>
            <div class="space-y-1">
              <input name="gc_workflow_sync" autocomplete="off" [(ngModel)]="editGithubCollab.workflows.sync" placeholder="sync (on private repo — e.g. .github/workflows/sync-from-collab.yml)"
                     class="bg-gray-50 border border-gray-300 text-gray-900 rounded-md block w-full p-2 font-mono text-xs dark:bg-gray-700 dark:border-gray-600 dark:text-white">
              <input name="gc_workflow_notify" autocomplete="off" [(ngModel)]="editGithubCollab.workflows.notify" placeholder="notify (on collab repo — e.g. .github/workflows/notify-f2-sync.yml)"
                     class="bg-gray-50 border border-gray-300 text-gray-900 rounded-md block w-full p-2 font-mono text-xs dark:bg-gray-700 dark:border-gray-600 dark:text-white">
            </div>
          </div>
          <!-- Customer collaborators -->
          <div>
            <label class="block mb-1 text-xs font-medium text-gray-700 dark:text-gray-300">Customer collaborators (one per line, optional <code class="text-app-teal-100">:role</code> suffix)</label>
            <textarea name="gc_collaborators" [(ngModel)]="editCollaboratorsText" rows="3"
                      placeholder="someuser
anotheruser:write
readonly-user:read"
                      class="bg-gray-50 border border-gray-300 text-gray-900 rounded-md block w-full p-2 font-mono text-xs dark:bg-gray-700 dark:border-gray-600 dark:text-white"></textarea>
            <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">GitHub handles granted access to the customer collab repo. Empty = no collaborators tracked here (source of truth is still GitHub's collab-repo permissions).</p>
          </div>
        </div>
      </div>
      <p *ngIf="editJsonError" class="mt-3 text-xs text-red-500">{{ editJsonError }}</p>
    </form>
    <!-- Sticky action bar — always visible so operator doesn't have to scroll to Save. -->
    <div class="flex-none py-3 px-6 border-t dark:border-app-black-300 dark:bg-app-black-100 flex gap-2">
      <button type="button" (click)="showEditScannerModal = false" class="dark-btn-secondary flex-1">Cancel</button>
      <button type="button" (click)="on_save_edit()" [disabled]="!can_save_edit()"
        class="dark-btn-primary flex-1" [class.dark-btn-disabled]="!can_save_edit()">Save changes</button>
    </div>
  </div>
</div>

<!-- Delete scanner modal -->
<div *ngIf="showDeleteScannerModal"
class="overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-40 w-full md:inset-0 h-full max-h-full
flex flex-col justify-center items-center
dark:bg-[rgba(1,1,1,0.8)]">
  <div class="flex-0 w-auto p-6">
    <h1 class="py-4 px-8 text-md font-semibold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white
    dark:bg-app-black-100">
      <i class="fa-solid fa-trash text-red-400 mr-2"></i> Delete Scanner Confirmation
    </h1>
    <div class="py-4 px-8 pb-8 dark:bg-gradient-to-b from-app-black-200 to-app-black-300 dark:text-gray-200">
      <p>Are you sure you want to delete the following scanner?</p>
      <div class="my-2 text-center text-red-400 mt-8">{{selected_scanner.Id}}</div>
      <div class="my-2 text-center text-red-400">{{selected_scanner.Name}}</div>
      <button type="submit" (click)="delete_scanner(selected_scanner)" class="dark-btn-primary w-full mt-8">
        Yes
      </button>
      <button (click)="showDeleteScannerModal = false" class="dark-btn-secondary w-full mt-1">
        No
      </button>
    </div>
  </div>
</div>


<!-- Inline Add Customer modal (launched from + button in scanner Client dropdown) -->
<div *ngIf="showAddCustomerModal"
class="overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 w-full md:inset-0 h-[calc(100%-1rem)] max-h-full
flex flex-col justify-center items-center
dark:bg-[rgba(1,1,1,0.85)]">
  <div class="flex-0 w-[400px] p-6">
    <h1 class="py-4 px-8 text-md font-semibold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white dark:bg-app-black-100">
      <i class="fa-solid fa-building text-blue-400 mr-2"></i> Add Customer
    </h1>
    <form class="py-4 px-8 pb-8 dark:bg-gradient-to-b from-app-black-200 to-app-black-300">
      <div>
        <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Slug (_id)*</label>
        <input name="new_customer_slug" autocomplete="off" [(ngModel)]="newCustomer._id"
               placeholder="e.g. option-pit"
               class="bg-gray-50 border border-gray-300 text-gray-900 rounded-md block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-strat_orange-100 dark:focus:border-strat_orange-100">
        <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
          Lower-kebab-case. Matches Cognito <code>custom:customers</code> + F2-ADMIN.Scanners.Client.
        </p>
      </div>
      <div class="mt-6">
        <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Display name*</label>
        <input name="new_customer_name" autocomplete="off" [(ngModel)]="newCustomer.name"
               placeholder="e.g. Option Pit"
               class="bg-gray-50 border border-gray-300 text-gray-900 rounded-md block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-strat_orange-100 dark:focus:border-strat_orange-100">
      </div>
      <p class="mt-4 text-xs text-gray-500 dark:text-gray-400">
        Other fields (domains, scanner_host, contacts, etc.) can be filled in later via
        the Customers page.
      </p>
      <button type="button" (click)="on_save_new_customer()" [disabled]="!can_save_new_customer()"
        class="mt-6 dark-btn-primary w-full" [class.dark-btn-disabled]="!can_save_new_customer()">
        Save
      </button>
      <button type="button" (click)="showAddCustomerModal = false; addCustomerOrigin = null" class="dark-btn-secondary mt-1 w-full">
        Cancel
      </button>
    </form>
  </div>
</div>
